import { Component, Input } from '@builder.io/sdk';

import sectionFields from 'molecules/Section/config';

import iconCardFields from 'organisms/Cards/IconCard/config';

const customCardFields = [
  {
    name: 'cards',
    type: 'list',
    subFields: iconCardFields,
    helperText:
      'Add up to 8 custom cards. Each card can include an icon, image, title, description, and optional button.',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      const cards = options.get('cards') || [];
      if (cards.length > 8) {
        options.set('cards', cards.slice(0, 8));
        alert('Maximum card count is 8. Removing excess cards.');
      }
    },
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const customCardConfig = {
  name: 'Custom Card',
  inputs: customCardFields,
} as Component;

export type CustomCardProps = GenerateBuilder<typeof customCardFields>;

export default customCardConfig;
